
import brand from '@/pages/basic/brand'
import classify from '@/pages/basic/classify'
import selection from '@/pages/basic/selection'
import goodsManage from '@/pages/basic/goodsManage'
import cashDeposit from '@/pages/basic/cashDeposit'
import storeSetup from '@/pages/basic/storeSetup'
import layout from '@/components/layout/layout'

const basicRouter =
{
  path: '/basic',
  component: layout,
  meta: {roles: ['shop', 'r4gys'], title: '基础设置', icon: 'icon-jichushezhi'},
  children: [
    {
      path: '/basic/classify',
      name: 'classify',
      component: classify,
      hidden: true,
      meta: {roles: ['shop', 'r4gys'], title: '分类设置'}
    },
    {
      path: '/basic/brand',
      component: brand,
      name: 'brand',
      hidden: true,
      meta: {roles: ['shop', 'r4gys'], title: '品牌管理'}
    },
    {
      path: '/basic/selection',
      name: 'selection',
      component: selection,
      meta: {roles: ['shop', 'r4gys'], title: '商品选品'}
    },
    {
      path: '/basic/goodsManage',
      name: 'goodsManage',
      component: goodsManage,
      meta: {roles: ['shop', 'r4gys'], title: '商品管理'}
    },
    {
      path: '/basic/cashDeposit',
      name: 'cashDeposit',
      component: cashDeposit,
      hidden: true,
      meta: {roles: ['shop', 'r4gys']}
    }
    // {
    //   path: '/basic/storeSetup',
    //   name: 'storeSetup',
    //   component: storeSetup,
    //   hidden: true,
    //   meta: {roles: ['shop'], title: '店铺设置'}
    // }
  ]
}
export const clickShow = function (val, route) {
  if (val) {
    route.children[0].hidden = false
    route.children[1].hidden = false
  } else {
    route.children[0].hidden = true
    route.children[1].hidden = true
  }
  return route
}
export default basicRouter



// WEBPACK FOOTER //
// ./src/router/modules/basicRouter.js